import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import * as layouts from "../../Layouts/index";

import homedata from "../../data/ContactUs";
import NavAndFooter from "../Common/NavAndFooterContainer";
import LoadingComponet from "../../components/Loading/LoadingComponet";
import GetPageData from "../../hooks/GetPageData";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      // backgroundColor: "white",
    },
  },
}));

const ContactUs = () => {
  const classes = useStyles();
  const { ready, data, error } = GetPageData("contact");
  return ready && data ? (
    <div className={classes.root}>
      <NavAndFooter>
        {data?.data?.map((data, index) => {
          const Layout = layouts[data?.layout];
          return <Layout key={index} data={data} />;
        })}
      </NavAndFooter>
    </div>
  ) : (
    <div>
      <LoadingComponet />
    </div>
  );
};
export default ContactUs;
